module.exports = __webpack_public_path__ + "img/ill_spot_da_out_of_range.5807611e.svg";